export const DATABASE_SEARCH_MAX_LENGTH = 200;

export const normalizeDatabaseSearchTerms = (search?: string): string[] => {
    return search
        ?.trim()
        .slice(0, DATABASE_SEARCH_MAX_LENGTH)
        .replace(/[%,_*()\n\r]/g, " ")
        .split(/\s+/)
        .filter(Boolean) || [];
};

export const databaseSearchPattern = (term: string): string => `%${term}%`;
